import axios from "axios";
import { APPROVAL_EVENT } from "@/lib/approval";

// Le chiamate AJAX della SPA (e i link costruiti con questo export, es.
// window.location.href/<img src> in Auth.js/Inbox.js: il browser li risolve
// da solo contro l'origine corrente) usano SEMPRE un percorso relativo — si
// risolve contro l'origine che ha servito la pagina, corretto in qualunque
// ambiente (dev server su una porta qualsiasi grazie al suo proxy /api ->
// backend; in produzione dietro un reverse proxy). Prima un URL assoluto
// hardcoded (REACT_APP_BACKEND_URL) rompeva le chiamate ogni volta che il
// frontend finiva su una porta diversa da quella prevista (es. la 3100 già
// occupata da un'altra sessione).
//
// REACT_APP_BACKEND_URL resta invariata e continua a essere letta altrove
// (Impostazioni.js) per costruire URL ASSOLUTI da copiare fuori dal browser
// — webhook Meta, redirect OAuth Google — che un percorso relativo non
// potrebbe mai sostituire.
export const API = "/api";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Approvazione manuale: un 403 con l'header X-Approval-Status (sospensione/rifiuto con la
// dashboard già aperta) avvisa l'AuthContext, che rilegge lo stato e mostra la pagina dedicata.
// L'errore resta quello originale: nessun chiamante cambia comportamento.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const flagged = error && error.response && error.response.status === 403
      && error.response.headers && error.response.headers["x-approval-status"];
    if (flagged) {
      try { window.dispatchEvent(new Event(APPROVAL_EVENT)); } catch { /* voluto */ }
    }
    // Blocco del piano (403 con X-Plan-Block-Reason): "Il mio piano" si aggiorna; il messaggio resta quello del backend nel `detail`.
    const planBlock = error && error.response && error.response.status === 403 && error.response.headers && error.response.headers["x-plan-block-reason"];
    if (planBlock) {
      try { window.dispatchEvent(new CustomEvent("aiposto:plan-block", { detail: { reason: planBlock, feature: error.response.headers["x-plan-block-feature"] } })); } catch { /* voluto */ }
    }
    return Promise.reject(error);
  },
);

// P2 espone l'identità del backend sulla health esistente. Manteniamo il
// controllo della copia/porta senza cambiare alcuna API.
const VERSIONE_ATTESA = process.env.REACT_APP_EXPECTED_VERSION;
if (VERSIONE_ATTESA) {
  api.get("/health").then(({ data }) => {
    if (String(data?.version) !== String(VERSIONE_ATTESA)) {
      console.error(`[identità] Frontend ${VERSIONE_ATTESA}, backend ${data?.version}. Controlla le porte.`);
    }
  }).catch(() => {});
}

export default api;
